import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import MyCoursesAll from "./Components/MyCoursesSection/MyCoursesAll";
import MyCoursesOngoing from "./Components/MyCoursesSection/MyCoursesOngoing";
import MyCoursesUpcoming from "./Components/MyCoursesSection/MyCoursesUpcoming";
import MyCoursesCompleted from "./Components/MyCoursesSection/MyCoursesCompleted";

import { Projectpage1 } from "./Components/Project_page1";
import { Profilepage1 } from "./Components/Profile_page1";
import { Paymentpage1 } from "./Components/Payment_page1";
import { Paymentpage2 } from "./Components/Payment_page2";
import { Paymentpage3 } from "./Components/Payment_page3";

// import CourseViewCard from "./Components/Course-view-card/CourseViewCard";
import CreativeCoursesDisplayPage from "./Components/CreativeCoursesDisplayPage/CreativeCoursesDisplayPage";
import AllCourses from "./Components/CoursesSection/AllCourses";
import CreativeCourses from "./Components/CoursesSection/CreativeCourses";
import TechnicalCourses from "./Components/CoursesSection/TechnicalCourses";
import AllDemoPage from "./Components/TakeAFreeLiveDemo/AllDemoPage";
import RecordedDemoPage from "./Components/TakeAFreeLiveDemo/RecordedDemoPage";
import UpcomingDemoPage from "./Components/TakeAFreeLiveDemo/UpcomingDemoPage";
import TodayDemoPage from "./Components/TakeAFreeLiveDemo/TodayDemoPage";

import { Home } from "./Components/Home/Home";
import { MentorPage } from "./Components/Mentor/MentorPage";
import PaymentSuccessfullPage from "./Components/PaymentSuccessfullPage/PaymentSuccessfullPage";
import { HomeAfterPayment } from "./Components/Home/HomeAfterPayment";
import { RegisterNow } from "./Components/Register/RegisterNow";
import { OtpPage } from "./Components/Register/OtpPage";

//Community pages
import { Community } from "./Components/Community/Community";
import { GigsDetails } from "./Components/Community/GigsDetails";
import { InternshipDetails } from "./Components/Community/InternshipDetails";
import { CoursePage } from "./Components/CoursePage/CoursePage";

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/courses">
            <AllCourses />
          </Route>
          <Route path="/courses-creative">
            <CreativeCourses />
          </Route>
          <Route path="/courses-technical">
            <TechnicalCourses />
          </Route>

          <Route path="/free-live-demo">
            <AllDemoPage />
          </Route>
          <Route path="/my-courses-all">
            <MyCoursesAll />
          </Route>
          <Route path="/all-free-demo">
            <AllDemoPage />
          </Route>
          <Route path="/today-free-demo">
            <TodayDemoPage />
          </Route>
          <Route path="/upcoming-free-demo">
            <UpcomingDemoPage />
          </Route>
          <Route path="/recorded-free-demo">
            <RecordedDemoPage />
          </Route>
          <Route path="/my-courses-ongoing">
            <MyCoursesOngoing />
          </Route>
          <Route path="/my-courses-upcoming">
            <MyCoursesUpcoming />
          </Route>
          <Route path="/my-courses-completed">
            <MyCoursesCompleted />
          </Route>
          <Route path="/creative-courses-display-page">
            <CreativeCoursesDisplayPage />
          </Route>

          <Route path="/verify">
            <OtpPage></OtpPage>
          </Route>
          {/* 
          <Route path="/register">
            <RegisterNow />
          </Route> */}

          <Route path="/mentors">
            <MentorPage />
          </Route>

          <Route path="/community">
            <Community />
          </Route>

          <Route path="/gigs-details">
            <GigsDetails />
          </Route>

          <Route path="/intern-details">
            <InternshipDetails />
          </Route>
          {/* ///////////////////////////////////////////////////////////// */}
          <Route path="/course-page">
            <CoursePage />
          </Route>
          {/* /////////////////////////////////// */}
          <Route path="/Paymentpage1">
            <Paymentpage1 />
          </Route>
          <Route path="/Paymentpage2">
            <Paymentpage2 />
          </Route>
          <Route path="/Paymentpage3">
            <Paymentpage3 />
          </Route>
          <Route path="/PaymentSuccessfullPage">
            <PaymentSuccessfullPage />
          </Route>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/HomeAfterPayment">
            <HomeAfterPayment />
          </Route>
          <Route path="/Projectpage1">
            <Projectpage1 />
          </Route>
          <Route path="/Profilepage1">
            <Profilepage1 />
          </Route>
          <Route path="/AllDemoPage">
            <AllDemoPage />
          </Route>
          <Route path="/" exact>
            <RegisterNow />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
